//myAccounts
import Vue from 'vue'
// import { postBlob } from "@/plugins/axios";

// 我的账号
export function getMyAccounts(data) {
    return Vue.axios({
        url: '/api/auth/myAccounts',
        method: 'get',
        params: {...data,}
    })
}

//我的权限
export function getPermissions(data) {
    return Vue.axios({
        url: '/api/auth/permissions',
        method: 'get',
        params: {...data,}
    })
}

//切换账号
export function switchAccount(id) {
    let data = {user_id: id}
    return Vue.axios({
        url: '/api/auth/switchAccount',
        method: 'post',
        data: {...data,}
    })
}

// 获取公钥
export function getPublicKey() {
    return Vue.axios({
        url: '/api/open/getPublicKey',
        method: 'get',
    })
}

// 获取滑动验证码配置信息
export function getCaptcha() {
    return Vue.axios({
        url: '/api/open/getCaptcha',
        method: 'get',
    })
}

// 验证滑动验证码
export function checkCaptcha(params) {
    return Vue.axios({
        url: '/api/open/checkCaptcha',
        method: 'get',
        params
    })
}